import { render, staticRenderFns } from "./ChartjsDoughnutChart2.vue?vue&type=template&id=c6dfbf82&"
import script from "./ChartjsDoughnutChart2.vue?vue&type=script&lang=js&"
export * from "./ChartjsDoughnutChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports